import { Content } from '../components';
import { type TermAndPolicyProps, useTermAndPolicyController } from '../core';

export const TermAndPolicyPage: React.FC<TermAndPolicyProps> = ({ name, storeKey }) => {
  const { parts, updated_at } = useTermAndPolicyController(storeKey);

  return <Content name={name} updated={updated_at} parts={parts} />;
};
